import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const invoiceLocaleModule: LocaleModule = {
  name: "invoice",
  messages: { en: en, it: it },
};
